import React, {Component} from 'react';
import { connect }          from 'react-redux';
import './index.scss';

import * as routes from '../../../../constants/routes';

//components
import {sendBenefitCoupon, getBenefitById} from "../../../../redux/actions";
import SubsidyPopup from '../subsidy_popup';

//assets
import step1 from 'assets/icons/acquired-step1.svg';
import step2 from 'assets/icons/acquired-step2.svg';
import step3 from 'assets/icons/acquired-step3.svg';
import desktop_exit from 'assets/icons/login-x-icon.svg';
import {getMediaPath} from "../../../../app/functions";
import { UpsalePopupStatus } from '../../../../app/enums';
import footer from 'containers/footer/footer';

class CouponFlow extends Component {

    
    constructor(props) {
        super(props);
        this.state = {
            step: 0,
            sendAgainCount: 0,
        };
        this.animateOut  = this.animateOut.bind(this);
        this.animateIn   = this.animateIn.bind(this);
    }


    /* add class for animation after it is inserted into the DOM */
    componentDidMount() {
        this.animateIn();

        if(this.props.isAcquired){
            this.setState({step: 2});
        }
    }
    animateIn() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({animation_class: 'active'});
            })
        })
    }
    /* first remove the active class for exit animation then call the callback */
    animateOut(callback) {
        this.setState({animation_class: ''});
        setTimeout(() => {
            if(callback) {
                callback(this.state.selected_id);
            }
            this.props.handleClose();
        }, 200);
    }

    handleStepUp = () =>{
        if (this.state.step === 0 && this.state.sendAgainCount < 3) {
            this.setState({sendAgainCount: this.state.sendAgainCount + 1});

            // send again regular coupon
            if (!this.props.purchased) {
                this.props.sendBenefitCoupon({benefitId: this.props.benefitId});
            }
            // send again payment coupon
            else {
                //api request to send the barcode sms
                this.props.sendBenefitCoupon({benefitId: this.props.benefitId});
            }
        }
        else if (this.state.step === 0 && this.state.sendAgainCount >= 3){
            this.setState({step: this.state.step + 1});
        }
        else {
            this.animateOut();
        }
    };

    handleContactOnClick = () =>{
        window.open(routes.contact,'_blank');
    };

    handleBtnClick = () =>{
      if (this.state.step === 2){
          this.props.sendBenefitCoupon({benefitId: this.props.benefitId});
      }
      if(this.props.purchased){
          this.props.action();
      }
      this.animateOut();
    };

    translates = () => {
        return this.props.transaction;
    }

    shouldShowSubsidyPopup = () => {
        return this.props.benefit.main?.benefit_type === '300' && 
               this.props.benefit.relatedBenefits && 
               this.props.benefit.relatedBenefits.length > 0 &&
               !this.props.benefit.isAcquired;
    }

    getTranslations = () => {
        return this.props.transaction;
    }

    getSubsidyPopupProps = () => {
        const translations = this.getTranslations();
        return {
            content: this.props.benefit.main?.upsell_popup_header_text || translations['upsell_popup_purchase_success_title'] || '',
            benefits: this.props.benefit?.relatedBenefits,
            handleClose: this.animateOut,
            backdropClick: this.animateOut,
            status: UpsalePopupStatus.SUCCESSFUL_PURCHASE,
            footerText: this.props.benefit.main?.upsell_popup_footer_text || '',
        };
    }

    getContent = () => {
        const step = this.state.step;
        const translations = this.getTranslations();

        getBenefitById({benefitId: this.props.benefitId});
        
        //text for regular coupon
        let icons = [step1,step2,step3];
        let titles = [translations['acquired_title_step1'] + ' ' + this.props.userDate.phone,translations['acquired_title_step2'],translations['acquired_title_step3']];
        let desc = [translations['acquired_desc_step1'],<div>{translations['acquired_desc_step2']} <span onClick={this.handleContactOnClick} className='contact'>{translations['acquired_desc_link_step2']}</span></div>,translations['acquired_desc_step3']];
        let btnTxt = [translations['acquired_btn_step1'],translations['acquired_btn_step2'],translations['acquired_btn_step3']];
        let smallText = [translations['acquired_small_text_step1'],translations['acquired_small_text_step2'],translations['acquired_small_text_step3']];

        //text for payment coupon
        if (this.props.purchased) {
            icons = [step1,step2];
            titles = [translations['purchased_popup_title'], translations['acquired_title_step2']];
            desc = [translations['purchased_popup_desc'], <div>{translations['acquired_desc_step2']} <span onClick={this.handleContactOnClick} className='contact'>{translations['acquired_desc_link_step2']}</span></div>];
        }

        return(
            <div>
                <img className='icon' src={getMediaPath(icons[step])} alt='/'/>
                <span className='step-title'>{titles[step]}</span>
                <div className='desc'>{desc[step]}</div>
                <button className='submit-btn' onClick={this.handleBtnClick}>{btnTxt[step]}</button>
                <span className='text' onClick={this.handleStepUp}>{smallText[step]}</span>
            </div>
        );
    };


    render() {
        // For type 300 benefits with related benefits (not acquired yet), show subsidy popup
        if (this.shouldShowSubsidyPopup()) {
            return <SubsidyPopup {...this.getSubsidyPopupProps()} />;
        }

        // For all other cases, show the standard coupon flow
        return (
            <div className = { "backdrop " + this.state.animation_class } onClick = { () => this.animateOut() }>
                <div className = {"popup_wrapper benefit-acquired " + this.state.animation_class} onClick = { (e) => e.stopPropagation() }>
                    <div className="popup_content">
                        <button className="x_close_icon"
                                onClick={() => this.animateOut()}
                                aria-label="סגור"><img src={getMediaPath(desktop_exit)} alt='/'/>
                        </button>
                        {this.getContent()}
                    </div>
                </div>
            </div>
        )
    }
}

//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.PopTrans,
        transaction: store.config.Translations,
        benefit: store.data.BenefitPage,
        userDate: store.config.UserData,
    }
}

const mapDispatchToProps = dispatch =>{
    return{
        sendBenefitCoupon: (payload) => dispatch(sendBenefitCoupon(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(CouponFlow);
